import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { useSiteActivationContext } from "@/components/signup/site-activation/hooks/site-activation-context";
import { ProductKey } from "@/components/signup/utils/products";
import { Button } from "@/libraries/design/components";

export const SwitchYourSiteMessage = () => {
    let homeCtaUrl = "https://home.atlassian.com";
    const { primaryCollectionProduct } = useSiteActivationContext();

    if (primaryCollectionProduct === ProductKey.ROVO) {
        homeCtaUrl = `${homeCtaUrl}/chat`;
    }

    return (
        <>
            <p css={contentCss}>
                <FormattedMessage
                    id="signup.teamworkCollection.uplift"
                    defaultMessage="You already have a site that qualifies to switch over to Teamwork Collection. Admins can convert existing sites to Teamwork Collection at Atlassian Administration."
                />
            </p>
            <Button
                variant="primary"
                css={buttonCss}
                href={homeCtaUrl}
                target="_self"
            >
                <FormattedMessage
                    id="signup.teamworkCollection.uplift.button"
                    defaultMessage="Back to Home"
                />
            </Button>
        </>
    );
};

const contentCss = css({
    textAlign: "center",
    marginBlockEnd: 36
});

const buttonCss = css({
    maxWidth: "none"
});
